import { Divider } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback } from 'react';

import type { VariableDropdownItem } from '../../types';

import styles from './item.module.scss';

type Props<TItem extends VariableDropdownItem> = {
  className?: string;
  item: TItem;
  onSelect: (item: TItem) => void;
};

export const VariableSelectorItem = <TItem extends VariableDropdownItem>({
  className,
  item,
  onSelect,
}: Props<TItem>): null | JSX.Element => {
  const handleClick = useCallback(() => {
    onSelect(item);
  }, [onSelect, item]);

  if ('divider' in item) {
    return <Divider />;
  }

  if ('content' in item) {
    const rootClass = classnames(
      {
        [styles.root]: true,
      },
      className,
    );

    return (
      <button type="button" className={rootClass} onClick={handleClick}>
        {item.content}
      </button>
    );
  }

  return null;
};
